import { PORTFOLIO_PAGE } from '../../constants/pages';
import { LANDING_PAGE } from '../../constants/sessionStorage';
import {
  removeFromSessionStorage,
  retrieveFromSessionStorage,
} from './sessionStorageHelper';

// AuthRoute (render) and login pages (effects) can both call this in the same
// turn after JWT is set. Remember the value briefly so the second caller does
// not fall through to BUY_PAGE and wipe a deep-link redirect.
let consumedLandingPage = null;

export const landingPageHelper = () => {
  const landingPage = retrieveFromSessionStorage(LANDING_PAGE);

  if (landingPage) {
    removeFromSessionStorage(LANDING_PAGE);
    consumedLandingPage = landingPage;
    setTimeout(() => {
      consumedLandingPage = null;
    }, 0);
    return landingPage;
  }

  if (consumedLandingPage) {
    const page = consumedLandingPage;
    consumedLandingPage = null;
    return page;
  }

  return PORTFOLIO_PAGE;
};
